import { getConfigApi } from 'Api/ConfigApi';
import React, { useEffect } from 'react';
import FooterContent from './FooterContent';
import { updateFooter } from 'State/Layout';
import { useStore } from 'Hooks/useStore';

export function Footer() {
  const footerContent = useStore('pageLayout.footerContent');

  useEffect(() => {
    const fetchAndUpdateFooterWithContent = async () => {
      try {
        const footerResponse = await getConfigApi('/footer');
        if (footerResponse.data) updateFooter(footerResponse.data);
      } catch (err) {
        console.error(err.message);
      }
    };
    if (!footerContent.isLoaded) {
      fetchAndUpdateFooterWithContent();
    }
  }, [footerContent.isLoaded]);

  if (!footerContent.isLoaded) {
    return null;
  }

  return <FooterContent {...footerContent.content} />;
}
